export default "__VITE_ASSET__FfbCnVP$__"